<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :model="filterData" :inline="true">
            <el-form-item>
              <el-input v-model="filterData.tenant"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="filterData.month" type="month" value-format="yyyy-MM" placeholder="月份"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">搜索</el-button>
              <el-button @click="onSearchSettlement">待结算</el-button>
              <el-button @click="onSearchUnsettlement">已结算</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="物业名称" prop="name"></el-table-column>
        <el-table-column label="结算月份" prop="month"></el-table-column>
        <el-table-column label="订单总金额" prop="total">
          <template slot-scope="scope">
            ￥{{ scope.row.total }}
          </template>
        </el-table-column>
        <el-table-column label="分佣比例" prop="ratio">
          <template slot-scope="scope">
            {{ scope.row.ratio }}%
          </template>
        </el-table-column>
        <el-table-column label="佣金总金额" prop="commission">
          <template slot-scope="scope">
            ￥{{ scope.row.commission }}
          </template>
        </el-table-column>
        <el-table-column label="结算状态" prop="status">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">已结算</el-tag>
            <el-tag type="primary" v-else>待结算</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="warning" @click="check(scope.row)">结算</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Settlements',
  data () {
    return {
      filterData: {
        tenant: '',
        month: '',
        settlement: 0
      },
      records: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList() {
      request.get('statements').then(res=>{
        this.records = res.data
      })
    },
    onSearch() {
      this.filterData.settlement = 0
      this.getList()
    },
    onSearchSettlement() {
      this.filterData.settlement = 1
      this.getList()
    },
    onSearchUnsettlement() {
      this.filterData.settlement = 2
      this.getList()
    },
    check (row) {
      this.$confirm(`确定该物业${row.month}月度账单已结算了吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
